import { Divider, Layout, message } from "antd";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import Brand from "../../components/brand";
import Flag from "../../components/flag";
import useDispatchWithResult from "../../hooks/useDispatchWithResult";
import {
  ambienteIdSelector,
  ambienteIdsSelector,
  ambienteNomeSelector,
  isAutenticadoSelector,
  isDiretorSelector,
  isGestorSelector,
  isOperadorSelector,
  isSuperUsuarioSelector,
  nomeSelector,
  sair,
  usuarioIdSelector,
} from "../../store/autenticacao";
import { isMDSelector, isXSSelector } from "../../store/layout";
import AlterarSenhaDrawer from "./_AlterarSenhaDrawer";
import SmtpDrawer from "./_SmtpDrawer";
import styles from "./_styles.less";
import axios from "axios";
import unwrapAxiosPromise from "../../util/unwrapAxiosPromise";
import Logo from "../../components/logo";
import useModulo from "../../hooks/useModulo";
import CustomModal from "../../components/modal-sobre";
import DropdownMenu from "@/components/dropdown-menu";
import usePaginas from "@/hooks/usePaginas";

export default function AuthenticatedLayout({ children, modulo, acessoModulo, menu, contentStyle }) {
  const { t, i18n } = useTranslation();
  const { aurthorizeModulo, authorizeAcessoModulo, moduloAtual, acessoModulosObjects } = useModulo();
  const { paginasPorSubgrupo } = usePaginas();
  const isXS = useSelector(isXSSelector);
  const isMD = useSelector(isMDSelector);
  const isAutenticado = useSelector(isAutenticadoSelector);
  const usuarioId = useSelector(usuarioIdSelector);
  const isDiretor = useSelector(isDiretorSelector);
  const isSuperUsuario = useSelector(isSuperUsuarioSelector);
  const isOperator = useSelector(isOperadorSelector);
  const isGestor = useSelector(isGestorSelector);
  const ambienteIds = useSelector(ambienteIdsSelector);
  const nome = useSelector(nomeSelector);
  const ambienteId = useSelector(ambienteIdSelector);
  const ambienteNome = useSelector(ambienteNomeSelector);
  const history = useHistory();
  const dispatch = useDispatchWithResult();
  const [alterarSenhaVisible, setAlterarSenhaVisible] = useState(false);
  const [smtpVisible, setSmtpVisible] = useState(false);
  const [ambientes, setAmbientes] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedKeysMenu, setSelectedKeysMenu] = useState([]);
  const [selectedKeysModulos, setSelectedKeysModulo] = useState([]);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  if (modulo) aurthorizeModulo(modulo);

  if (acessoModulo) authorizeAcessoModulo(acessoModulo);

  useEffect(() => {
    if (ambienteId) setSelectedKeysMenu([ambienteId.toString()]);
    if (moduloAtual) {
      const moduloAux = acessoModulosObjects.find((atual) => atual.id === moduloAtual);
      setSelectedKeysModulo(moduloAux ? [moduloAux.location] : []);
    }
  }, [ambienteId, moduloAtual]);

  useEffect(() => {
    if (!isAutenticado) history.push("/autenticar");
  }, [isAutenticado]);

  useEffect(() => {
    if (ambienteIds.length > 0 || isSuperUsuario)
      unwrapAxiosPromise(axios.get("/ambientes")).then((data) => {
        setAmbientes(data);
      });
    else setAmbientes([]);
  }, [ambienteIds, isSuperUsuario]);

  const handleLogoClick = (e) => {
    e.preventDefault();
    history.push("/");
  };

  const handleMenuClick = ({ key }, moduloVal) => {
    history.push(key);
    moduloVal && setSelectedKeysModulo(moduloVal);
  };

  const handleAmbienteClick = ({ key }) => {
    setSelectedKeysMenu([ambienteId.toString()]);
    unwrapAxiosPromise(
      axios.post(`/usuarios/${usuarioId}/alterar-ambiente`, {
        ambienteId: Number(key),
      })
    ).then(() => (location.pathname = "/"));
  };

  const handleLanguageClick = ({ key }) => {
    i18n.changeLanguage(key);
  };

  const handleAlterarSenhaClick = () => {
    setAlterarSenhaVisible(true);
  };

  const handleSmtpClick = () => {
    setSmtpVisible(true);
  };

  function formatarModulo(modulo) {
    const MODULO_LABELS = {
      regulatorio: "Regulatório",
      societario: "Societário",
      compliance: "Compliance",
      consultivo: "Consultivo",
      workflow: "Workflow",
      dataanalytics: "Data Analytics",
    };
    if (!modulo) return "";
    return MODULO_LABELS[modulo.toLowerCase().replace(/[^a-zA-Z0-9]/g, "")] || modulo;
  }

  const handleSairClick = () => {
    dispatch(sair()).finally(() => {
      message.info(t("Você saiu"));
      history.push("/autenticar");
    });
  };

  const menuDropdownItems = [
    { key: "nome", label: <span style={{ color: "#009fff", fontWeight: "bold" }}>{nome}</span>, disabled: true, hidden: !isXS },
    { key: "/", label: t("Home"), onClick: handleMenuClick },
    { key: "/change-password", label: t("Alterar Senha"), onClick: handleAlterarSenhaClick },
    {
      key: "ambientes-submenu",
      popupClassName: "dropdown-content",
      label: t("Alterar Ambiente"),
      hidden: !(ambientes.length > 0 || isSuperUsuario),
      children: ambientes.map((ambiente) => ({
        key: ambiente.id,
        label: (
          <div className="ambiente-menu-item">
            <Logo src={ambiente.logo?.url} width={24} height={24} />
            <span>{ambiente.nome}</span>
          </div>
        ),
        onClick: () => handleAmbienteClick({ key: ambiente.id }),
      })),
    },
    {
      key: "language-submenu",
      popupClassName: "dropdown-content popup-languages",
      label: (
        <span className="item-language">
          <Flag countryCode={i18n.language.substr(-2)} />
          {i18n.language.substr(-2)}
        </span>
      ),
      children: [
        {
          key: "pt-BR",
          label: (
            <span>
              <Flag countryCode="BR" /> BR
            </span>
          ),
          onClick: handleLanguageClick,
        },
        {
          key: "en-US",
          label: (
            <span>
              <Flag countryCode="US" /> US
            </span>
          ),
          onClick: handleLanguageClick,
        },
        {
          key: "es-ES",
          label: (
            <span>
              <Flag countryCode="ES" /> ES
            </span>
          ),
          onClick: handleLanguageClick,
        },
      ],
    },
    { key: "about", label: t("Sobre nós"), onClick: openModal },
    { type: "divider" },

    isDiretor && {
      key: "configuracao-submenu",
      popupClassName: "dropdown-content",
      label: t("Configurações"),
      children: paginasPorSubgrupo["Configurações"]?.map((p) => ({
        key: p.key,
        label: p.label,
        onClick: handleMenuClick,
      })),
    },
    isOperator && {
      key: "historico-submenu",
      popupClassName: "dropdown-content",
      label: t("Histórico"),
      children: paginasPorSubgrupo["Histórico"]?.map((p) => ({
        key: p.key,
        label: p.label,
        onClick: handleMenuClick,
      })),
    },

    { key: "/assinaturas", label: t("Envelopes"), onClick: handleMenuClick, hidden: !isDiretor },
    { key: "/resumo/diario", label: t("Resumo Diário"), onClick: handleMenuClick, hidden: !isSuperUsuario },
    { key: "/importador/arquivos", label: t("Importador de Arquivos"), onClick: handleMenuClick, hidden: !isGestor },
    { key: "/smtp", label: t("SMTP"), onClick: handleSmtpClick, hidden: !isSuperUsuario },

    isDiretor && { type: "divider" },
    { key: "/quit", label: t("Sair"), onClick: handleSairClick },
  ];

  const modulosDropdownItems = [
    ...acessoModulosObjects.map((moduloAtual) => {
      return {
        key: moduloAtual.location,
        label: moduloAtual.label,
        onClick: () => handleMenuClick({ key: moduloAtual.location }, [moduloAtual.location]),
      };
    }),
  ];

  return (
    <Layout className={styles["authenticated-layout"]}>
      <Layout.Header theme="dark" className={styles["header"]}>
        <div className={styles["brand"]} onClick={handleLogoClick}>
          <Brand height="24px" theme="dark" iconOnly={!isMD} />
        </div>
        <Divider type="vertical" className={styles["divider"]} />
        <div className={styles["ambiente"]}>
          <Logo src={"/api/ambientes/" + ambienteId + "/logo.png"} width={24} height={24} />
          {!isXS && <span>{ambienteNome}</span>}
        </div>

        <Divider type="vertical" className={styles["divider"]} />

        {modulo && (
          <DropdownMenu menuProps={{ items: modulosDropdownItems, selectedKeys: selectedKeysModulos }} trigger={["click"]} placement="bottomLeft">
            <DropdownMenu.Button tooltipTitle="Selecionar Módulo">{formatarModulo(modulo)}</DropdownMenu.Button>
          </DropdownMenu>
        )}

        <div className={styles["menu"]}>{menu}</div>
        <Divider type="vertical" className={styles["divider"]} />

        <DropdownMenu menuProps={{ items: menuDropdownItems, triggerSubMenuAction: "click", selectedKeys: selectedKeysMenu }} trigger={["click"]} placement="bottom">
          <DropdownMenu.Button tooltipTitle="Menu">{nome}</DropdownMenu.Button>
        </DropdownMenu>
      </Layout.Header>
      <Layout.Content className={styles["content-wrapper"]} style={contentStyle}>
        {children}
        <CustomModal open={isModalOpen} onCancel={closeModal} />
      </Layout.Content>
      <AlterarSenhaDrawer visible={alterarSenhaVisible} onClose={() => setAlterarSenhaVisible(false)} />
      <SmtpDrawer visible={smtpVisible} onClose={() => setSmtpVisible(false)} />
    </Layout>
  );
}

AuthenticatedLayout.propTypes = {
  children: PropTypes.node,
  menu: PropTypes.node,
  contentStyle: PropTypes.object,
};
